import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import { purple, green, red, blue, indigo, teal, grey } from '@material-ui/core/colors';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CustomButtonOLLight from './CustomButtonOLLight';
import CustomButtonOLDailyBlue from './CustomButtonOLDailyBlue';
import CustomButtonOLDailyDigital from './CustomButtonOLDailyDigital';
import NewsList from './NewsList';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

/**
* 折り畳み表示
* 'openHere'というクラスに属するオブジェクトをインライン要素or非表示に変更する。
*/
const openClose = (id) => {
  console.log(id);
  var obj = document.getElementsByClassName(`openHere ${id}`);
  for(var i=0;i<obj.length;i++){
      //非表示ならインライン要素に変更。表示状態なら非表示に変更。
      if(obj[i].style.display == "inline-block"){
          obj[i].style.display = "none";
      }
      else{
          obj[i].style.display = "inline-block";
      }
  }
}

const testClick = () => {
  alert(`ボタンがクリックされました`);
}

function Home() {
  const classes = useStyles();
  {/*
  // お知らせテスト
  window.onload = function () {
  // ロード時にAPIを呼び出す
    const API_URL = "https://api.sssapi.app/vPxrQ3DPI0c3Dg9o4AOrC";
    fetch(API_URL).then((response) => {
      if (response.status != 200) {
        // APIの呼び出しが失敗した場合
        console.log(response.status);
        return response
          .json()
          .then((error) => alert(JSON.stringify(error, null, 2)));
      }

      // APIの呼び出しが成功した場合
      return response
        .json() // JSONデータを取得
        .then((data) => {
          // 取得したデータを挿入
          document.getElementById("infomation").innerHTML += `<span onclick={testClick}>ここをクリック</span>`;
        });
    });
  };
  */}

  return (
    <div className={classes.root}>
      <div className="wrap">
        {/* <video autoPlay muted playsInline loop id="bg-video">
          <source src="/movie/movie-bg.webm" type="video/webm"></source>
          <source src="/movie/movie-bg.mp4" type="video/mp4"></source>
          <source src="/movie/movie-bg.ogg" type="video/ogg"></source>
        </video> */}

        <Box className="content-wrap">
          <div className="header-title">
            {/*
              <Grid className="p-3 my-4" spacing={0} container direction="row" justify="center">
                <Grid item xs={10} sm={8} md={6}>
                  <img src="/images/logo-top.png" className="img-fluid" />
                </Grid>
              </Grid>
            */}

            <div className="top-menu-wrap">

              <div className="top-menu-content text-left">

                {/*
                <Grid spacing={1} container direction="row" justifyContent="center" alignItems="center">
                  <Grid item xs={12} sm={9} md={9}>
                    <Grid spacing={1} container direction="row" justifyContent="center" alignItems="center" style={{ margin: "3.0rem 0", border: "2px solid red", padding: "0.5rem 1.5rem" }}>
                      <Grid item xs={12} sm={8} md={8}>
                        【復旧のお知らせ】<br />
                        ニュースサイト「デーリー東北デジタル」は19日午後４時ごろからシステム障害のため閲覧できない状態になっておりましたが、同日午後９時ごろ復旧いたしました。ユーザーの皆様にはご不便とご迷惑をおかけしましたことをあらためてお詫び申し上げます。<br />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <div class="text-center mx-auto my-3">
                          <a href="https://static.daily-tohoku.news/nepcell/viewer/viewer.html">
                            <img src="https://static.daily-tohoku.news/nepcell/viewer/images/sougou1men.png" class="img-fluid" /><br />
                            <small class="my-2 text-danger">画像をクリックすると電子紙面が閲覧できます。</small>
                          </a>
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                */}

                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={12} sm={5} md={4}>
                    <div class="p-2">
                      <img src="/images/michill-tanesashi-grand-open.jpg" className="img-fluid" />
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={7} md={8}>
                    <Typography className="text-left my-3" variant="h6" component="h2">ミチル種差グランドオープン　景勝地に新たな観光拠点</Typography>
                    　デーリー東北新聞社（広瀬知明社長）が八戸市鮫町の種差海岸芝生地エリアに整備した、飲食と宿泊を核とする複合施設「ミチル種差」が５月２７日、グランドオープンしました。記念セレモニーで関係者がテープカットを行い、八戸が誇る景勝地に誕生した新たな観光拠点のスタートを祝いました。ディナーとセレクトショップ、宿泊を含めたフル営業が始まり、種差観光の通年化と魅力創出を目指します。<br />
                    　セレモニーで、施設を運営する子会社「ＤＴプロジェクト」の荒瀬潔代表（デーリー東北新聞社会長）は「種差の魅力を伝え、観光を下支えすることで新しい風が吹き始めてほしい」とあいさつ。熊谷雄一市長らが祝辞を述べました。<br />
                    　続いて市立種差小の全校児童１６人が登場。種差に魅了された詩人佐藤春夫が作詞を手がけ、美しい海辺の風景を表現した校歌を斉唱し、式典に花を添えました。<br />
                    　レストラン棟ではディナーの提供が始まりました。予約客が早速訪れ、フレンチとイタリアンを融合させた創作料理を優雅に味わいました。北奥羽地方の旬の食材を使ったディナーは予約制で、フルコース２種（税込み７７００円と１万１千円）から選べます。<br />
                    　併設ショップ「１ｔｏ９（ワントゥナイン）」では、北奥羽各地から厳選した逸品を販売。デザインや食材にこだわった菓子や飲料、土産品、伝統工芸品を多彩にそろえ注目を集めました。<br />
                    　宿泊施設は戸建てタイプの全３棟で、各棟４人（当面２人で、３人以上は要相談）まで利用できます。平日１泊２食付きのドリンク込みで、大人１人２万８５００円（税込み）からになります。<br />
                    　先行営業したランチやカフェ、テイクアウトは好評で、この日も多くの客が利用しました。周辺の海や天然芝生地を観光中に立ち寄り、ジェラートや軽食をテイクアウトする人も目立ちました。<br />
                    　弘前市から訪れた会社員五十嵐耀一さん（２７）は「ショップの土産品が特徴的で面白かった。宿泊施設も良さそうなので、泊まってみたい」と話していました。<br />
                    　問い合わせはＤＴプロジェクト＝電話０１７８（７０）５２５６、午前１０時～午後５時＝へ。<br />
                    【写真説明】<br />
                    ミチル種差のグランドオープンを祝い、テープカットする関係者＝５月２７日、八戸市鮫町<br />
                  </Grid>
                </Grid>

              </div>


              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">デーリー東北からのお知らせ</Typography>
                <NewsList/>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">会社案内</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-overview" className="aaa px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">会社概要</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://recruit.daily-tohoku.company/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">採用情報</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-shop" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">購読のご案内</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-advertisement" className="aaa px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">広告・折込のご案内</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">事業・チケット案内</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://event-guide.daily-tohoku.news/#sec-event" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">主催事業</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://event-guide.daily-tohoku.news/#sec-ticket" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">チケット情報</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/forum" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">政経懇話会</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">各種サービス</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://tomonokai.daily-tohoku.news/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デーリー友の会</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://event-guide.daily-tohoku.news/about-delion" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デリオンとは</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-facility" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">ホール貸出</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://form.daily-tohoku.org/shoseki-top" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">書　籍</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/support" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">後援願い</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="https://form.daily-tohoku.org/" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">バックナンバー販売</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/printservice" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">掲載写真販売</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/tour" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">会社見学</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-service" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">NIE</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={8} md={6}>
                    <CustomButtonOLDailyDigital href="https://www.daily-tohoku.news" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">デーリー東北・デジタル版へ　<i class="fas fa-arrow-circle-right"></i></div>
                    </CustomButtonOLDailyDigital>
                  </Grid>
                </Grid>
              </div>

              <div className="top-menu-content">
                <Typography className="text-left my-3" variant="h6" component="h2">投稿・各種お問い合わせ</Typography>
                <Grid spacing={1} container direction="row" justify="left" alignItems="center">
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/guide-wanted" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">投稿・応募</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue href="/contactus" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">お問い合わせ</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  {/*
                  <Grid item xs={6} sm={4} md={3}>
                    <CustomButtonOLDailyBlue id="open" href="/info" className="px-1 py-2 d-block" size="small" themeColor={grey}>
                      <div className="absolute-transform line160">関連会社役員の新型コロナ<br />ウイルス感染について</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <CustomButtonOLDailyBlue id="open" href="javascript:void(0);" className="px-1 py-3 d-block" size="large" themeColor={grey}>
                      <div className="absolute-transform">もっと「つかって」デーリー東北</div>
                    </CustomButtonOLDailyBlue>
                  </Grid>
                  */}
                </Grid>
              </div>
            </div>
          </div>
          {/*
          <div className="d-none d-md-block">
            <img src="/images/da002.png" className="img-fluid" />
          </div>
          */}
        </Box>
      </div>
    </div>
  );
}

export default Home;
